import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ModelType } from 'src/app/core/config/chart-colors-config';
import Constants from 'src/app/core/constants/constants';

@Component({
  selector: 'app-filter-recommendation-graph',
  templateUrl: './filter-recommendation-graph.component.html',
  styleUrls: ['./filter-recommendation-graph.component.scss'],
})
export class FilterRecommendationGraphComponent {
  @Input() models: { 
    model: string; 
    startDate: Date; 
    endDate: Date; 
    totalConsumption: number; 
    elecEnergySavings: number; 
    gasEnergySavings: number; 
  }[] = [];
  
  @Output() filterChange = new EventEmitter<string[]>();
  @Output() viewTypeChange = new EventEmitter<string>();
  @Output() showOptionalGraph = new EventEmitter<{action:boolean, type:string}>();

  @Input() set percentageSplitAvailable(value: boolean) {
    this.additionalGraphOptions.find(option => option.id === 'energySplit')!.isVisible = value;
  }

  
  selectedConsumptionTypes: string[] = ['combined'];
  selectedViewType: string = Constants.TIMELINE_TYPE.MONTH;

  // Options for the radio buttons
  consumptionOptions = [
    { label: 'Cumulative consumption', id: 'combined', value: 'combined', name: 'combined' },
    { label: 'Electric consumption', id: 'elec', value: 'elec', name: 'combined' },
    { label: 'Gas consumption', id: 'gas', value: 'gas', name: 'combined' },
    // { label: 'Carbon Emission', id: 'carbonEmmission', value: 'carbonEmmission', name: 'combined' },
  ];

   // View Type Options
   viewTypeOptions = [
    { id: Constants.TIMELINE_TYPE.MONTH, label: 'Monthly', value: Constants.TIMELINE_TYPE.MONTH },
    { id: Constants.TIMELINE_TYPE.YEAR, label: 'Yearly', value: Constants.TIMELINE_TYPE.YEAR },
  ];

  // Additional graph Options
  additionalGraphOptions = [
    { id: 'carbonEmission', label: 'Carbon Emission', value: 'carbonEmission', isVisible: true },
    { id: 'energySplit', label: 'Energy Splits', value: 'energySplit', isVisible: false },
    { id: 'energyIntensity', label: 'Energy Intensity', value: 'energyIntensity', isVisible: true },
    { id: 'carbonIntensity', label: 'Carbon Intensity', value: 'carbonIntensity', isVisible: true },
  ];
  

  // Handle Checkbox Changes
  onCheckboxChange(event: Event, value: string): void {
    const isChecked = (event.target as HTMLInputElement).checked;

    if (isChecked) {
      if (!this.selectedConsumptionTypes.includes(value)) {
        this.selectedConsumptionTypes.push(value);
      }
      
      this.additionalGraphOptions.find(option => option.id === 'energySplit')!.isVisible = value !== 'combined';
    } else {
      this.selectedConsumptionTypes = this.selectedConsumptionTypes.filter(
        (type) => type !== value
      );
    }

    this.filterChange.emit([value]);
  }

  onViewTypeChange(viewType: string): void {
    this.selectedViewType = viewType;
    // Emit updated view type
    this.viewTypeChange.emit(this.selectedViewType);
  }

  onViewAdditionalGraph(e: Event, graphType: string): void {
    const element = e.currentTarget as HTMLInputElement;
    this.showOptionalGraph.emit({action: element.checked, type: graphType});
  }
}
